/**
 * Normalized structure for excursion report data
 */

const getReportType = data => {
  if (data.sites) return 'site';
  if (data.shipments) return 'shipment';
  return null;
};

const reportConfig = {
  site: {
    groupsKey: 'sites',
    itemsKey: 'appliances',
    groupLabel: 'Site',
    itemLabel: 'Application'
  },
  shipment: {
    groupsKey: 'shipments',
    itemsKey: 'cargo',
    groupLabel: 'Shipment',
    itemLabel: 'Cargo'
  }
};

const getReportConfig = data => {
  const type = getReportType(data);
  return type ? reportConfig[type] : null;
};

const getGroups = data => {
  const config = getReportConfig(data);
  if (!config) return [];
  return data[config.groupsKey] || [];
};

const getItems = (group, data) => {
  const config = getReportConfig(data);
  if (!config) return [];
  return group[config.itemsKey] || [];
};

export const getAllExcursions = data => {
  const groups = getGroups(data);
  return groups.flatMap(group => getItems(group, data).flatMap(item => item.excursions));
};

export const countAffectedItems = data => {
  const groups = getGroups(data);
  return groups.reduce(
    (acc, group) =>
      acc + getItems(group, data).filter(item => item.excursions?.length > 0).length,
    0
  );
};

export const getLabels = data => {
  const config = getReportConfig(data);
  if (!config) {
    return { groupLabel: 'Group', itemLabel: 'Item' };
  }
  return {
    groupLabel: config.groupLabel,
    itemLabel: config.itemLabel
  };
};

/**
 * Normalize report data to unified structure for iteration
 * Returns array of { group, item, excursions } for easy mapping
 */
export const normalizeForIteration = data => {
  const groups = getGroups(data);
  const result = [];

  groups.forEach(group => {
    getItems(group, data).forEach(item => {
      result.push({
        group: { id: group.id, label: group.label },
        item: { id: item.id, label: item.label },
        excursions: item.excursions
      });
    });
  });

  return result;
};
